import { useNavigate } from "@reach/router";
import { useEffect } from "react";
import { useDispatch } from "react-redux";

interface IProps {
  path?: string;
}

export const Home = (_props: IProps) => {
  const navigate = useNavigate();

  const dispatch = useDispatch();

  useEffect(() => {
    navigate("/wizardStepOne");
  }, [navigate, , dispatch]);

  return (
    <>
      <p>Welcome to the platform!</p>
      <p>We will redirect you to the wizard</p>
    </>
  );
};
